export default __webpack_public_path__ + "static/media/480_private03-es-mobile.2e806e4f.png";